import { Pipe, PipeTransform, inject } from '@angular/core';
import {LorenAssetService} from '../../../../features/loren-assets/services/loren-asset-service/loren-asset.service';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Pipe({
    name: 'lorenImage',
    standalone: false
})
export class LorenImagePipe implements PipeTransform {
    private assetService = inject(LorenAssetService);

    transform(value: string): Observable<string> {
        return this.assetService.getAssetImageObservable(value).pipe(catchError(err => {
               return of(err);
        }));
    }

}
